<template>
    <v-form @submit.prevent="updateSchedule" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">Update Payment Schedule</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-select
                            label="Status"
                            :items="status_types"
                            :rules="[rules.required]" 
                            item-text="statusDescription"
                            item-value="statusCode"
                            :disabled="disabled"
                            v-model="status"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-row"> 
                        <v-text-field label="Amount Due" 
                            v-model="amountDue" 
                            :disabled="disabled"
                            :rules="[rules.required_numeric, rules.max_amount, rules.min_amount]"
                            type="number" min="1" step="1" value="0.00" 
                            ></v-text-field>  
                    </v-flex>
                </v-layout>  
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import cashadvancesApi from '@/api/cashadvances'

export default {
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required field.',
                required_numeric: value => !!value || 'Required field. Numeric Only',
                max_amount: value => value<=100000 || 'Invalid Amount. Maximum of 100,000.00',
                min_amount: value => value>=1 || 'Invalid Amount. Minimum of 1.00',
            },   
            status_types: [
                { statusCode: 10, statusDescription: 'Pending Payment' },
                { statusCode: 35, statusDescription: 'On Hold' },
            ],
            cashAdvancesId: null,
            cashAdvancesScheduleId: null,
            amountDue: null,
            status: null,
            dueOn: null,
        }
    },
    methods: {
        async updateSchedule() {
            try {
                this.loading = true
                this.disabled = true
                if (this.$refs.form.validate()) {
                    var data = {
                        cashAdvancesId: this.cashAdvancesId,
                        cashAdvancesScheduleId: this.cashAdvancesScheduleId,
                        amountDue: this.amountDue,
                        status: this.status,
                        dueOn: this.dueOn
                    }
                    const response = await cashadvancesApi.updateSchedule(data)
                    if (response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setData(data) {
            this.cashAdvancesId = data.cashAdvancesId
            this.cashAdvancesScheduleId = data.cashAdvancesScheduleId
            this.amountDue = data.amountDue
            this.status = data.status
            this.dueOn = data.dueOn
        },
        closeDialog() {
            this.$emit('update:dialogEditSchedule', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.remarks = ''
            this.loading = false
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
    },
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 15px 0px 15px;
}
</style>